var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26917",
    "data-name": "Group 26917",
    transform: "translate(-13514 8437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7608",
    "data-name": "Rectangle 7608",
    transform: "translate(13514 -8437)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_202",
    "data-name": "Subtraction 202",
    d: "M-812.158,670.307h-6.273a2.452,2.452,0,0,1-1.742-.729,2.445,2.445,0,0,1-.724-1.739v-6.275a2.463,2.463,0,0,1,.724-1.743,2.445,2.445,0,0,1,1.742-.721h6.273a2.45,2.45,0,0,1,1.744.721,2.452,2.452,0,0,1,.721,1.743v.291a.055.055,0,0,0,.025.044.049.049,0,0,0,.025.007.047.047,0,0,0,.026-.008l2.678-1.6a.66.66,0,0,1,.3-.088h.014a.621.621,0,0,1,.432.174.622.622,0,0,1,.189.445v7.754a.63.63,0,0,1-.3.533.031.031,0,0,0-.014.006.6.6,0,0,1-.3.077.617.617,0,0,1-.317-.086l-2.684-1.608a.039.039,0,0,0-.025-.007.052.052,0,0,0-.025.006.051.051,0,0,0-.025.043v.3a2.418,2.418,0,0,1-.724,1.739A2.432,2.432,0,0,1-812.158,670.307Zm-6.273-9.968a1.224,1.224,0,0,0-.869.352,1.222,1.222,0,0,0-.357.874v6.275a1.217,1.217,0,0,0,.357.869,1.22,1.22,0,0,0,.869.356h6.273a1.222,1.222,0,0,0,.871-.356,1.225,1.225,0,0,0,.356-.869v-6.275a1.213,1.213,0,0,0-.356-.869,1.221,1.221,0,0,0-.871-.356Zm11.144,1.621a.041.041,0,0,0-.025.007l-2.355,1.408a.051.051,0,0,0-.025.043v2.569a.049.049,0,0,0,.025.042l2.355,1.409a.041.041,0,0,0,.025.007.055.055,0,0,0,.026-.006.053.053,0,0,0,.025-.044v-5.385a.054.054,0,0,0-.025-.044A.068.068,0,0,0-807.287,661.959Z",
    transform: "translate(14335.449 -9093.703)",
    fill: "#6d809f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.e4d5230b721f672f45e4d667278bac38.svg";
export { ForwardRef as ReactComponent };